/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDocumentExclusionTermRequest
 */
export interface CreateDocumentExclusionTermRequest {
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    term: string;
}

/**
 * Check if a given object implements the CreateDocumentExclusionTermRequest interface.
 */
export function instanceOfCreateDocumentExclusionTermRequest(value: object): value is CreateDocumentExclusionTermRequest {
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('term' in value) || value['term'] === undefined) return false;
    return true;
}

export function CreateDocumentExclusionTermRequestFromJSON(json: any): CreateDocumentExclusionTermRequest {
    return CreateDocumentExclusionTermRequestFromJSONTyped(json, false);
}

export function CreateDocumentExclusionTermRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDocumentExclusionTermRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'term': json['term'],
    };
}

export function CreateDocumentExclusionTermRequestToJSON(json: any): CreateDocumentExclusionTermRequest {
    return CreateDocumentExclusionTermRequestToJSONTyped(json, false);
}

export function CreateDocumentExclusionTermRequestToJSONTyped(value?: CreateDocumentExclusionTermRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'term': value['term'],
    };
}

